// Vendor imports
const qs = require('qs')
// Client lib imports
const businessEvents = require('client/lib/business-events')
// Client V2 common imports
const commonClient = require('client-v2/common/client')
// Entry imports
const configureStore = require('./state/store')
const rootFactory = require('./components/root').factory
const { showArticleProfileModal } = require('./containers/feed/actions')

commonClient.runAfterPageIsLoaded(() => {

  const { store } = commonClient.render(configureStore, rootFactory)

  const initialState = store.getState()

  const businessEventsPageActions = {
    'search.showDomainPosts': 'posts',
    'search.showQueryCollections': 'mixes',
    'search.showQueryInterests': 'interests',
    'search.showQueryPeople': 'mixes',
    'search.showQueryPosts': 'posts'
  }
  const pageAction = businessEventsPageActions[initialState.router.action]
  commonClient.configureSession(store, {
    pageName: `search.${pageAction}`
  })

  businessEvents.trackInternal('pageview')
  businessEvents.trackSegment('pageview')

  const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true })
  if (pageAction === 'posts' && queryParams.modal) {
    store.dispatch(showArticleProfileModal())
  }

})
